import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import { isMobile, isTablet } from "../../../@css-style";

export const ElProgram = styled.section`
  width: 100%;
  display: flex;
  /* padding: 10px; */
  position: relative;
  justify-content: space-between;
  font-family: "Plus Jakarta Sans", sans-serif;
  font-weight: 100;
  font-style: normal;
  padding: 5em 0;
  background-attachment: fixed; /* KEY for parallax */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-color: transparent;
  background: linear-gradient(180deg, #e9f5ff 700%, rgba(229, 239, 255, 0.26) 83.7%, rgba(229, 239, 255, 0) 700%);
  ${String(isMobile)} {
    padding: 2em 0;
  }
  * {
    font-family: "Plus Jakarta Sans", sans-serif;
  }
`;

export const ElProgramContent = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 2em;
  padding: 10px;
  align-items: center;
  justify-content: center;
`;

export const ElColumn = styled.div<{ "data-color"?: string }>`
  width: 50%;
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  /* padding: 2em; */
  gap: 1em;
  text-align: left;
  img {
    max-width: 100%;
    width: 100%;
    height: auto;
    object-fit: contain;

    border-radius: 5px;
  }
  h2 {
    font-size: 36px;
    display: block;
    width: 100%;
    color: #ffffff;
    font-weight: 700;
    &[data-color="green"] {
      color: var(--theme-main-green-color);
      text-shadow: 0px 0px 15px rgba(255, 244.37821361058602, 233.38043478260872, 0.87);
    }
  }
  h3 {
    font-size: 17px;
    font-weight: 600;
    display: block;
    width: 100%;
    * {
      text-transform: uppercase;
    }
    [data-color="green"] {
      color: var(--theme-main-green-color);
      /* text-shadow: 0px 0px 15px rgba(255, 244.37821361058602, 233.38043478260872, 0.87); */
    }
  }

  p {
    color: #4d4d4d;
    font-size: 15px;
    font-weight: 400;
    display: flex;
    flex-direction: column;
    gap: 10px;
    line-height: 1.6em;
  }
  a {
    font-size: 15px;
    font-weight: 400;
    /* color: var(--theme-main-color); */
  }
  ${isMobile} {
    width: 100% !important;
    justify-content: center;
    align-items: center;
    flex: none !important;
  }
`;

export const elGapProgram = css`
  gap: 20px;
  position: relative !important;
  z-index: 2 !important;
`;

export const elBgWhite = css`
  /* background-color: #fff; */
  /* box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.18); */
  border-radius: 10px;
`;
